import {graphql, useFragment, usePaginationFragment} from 'react-relay'
import type {IssueViewerIssue$data} from '../__generated__/IssueViewerIssue.graphql'
import type {IssueTimelineSecondary$key} from '../__generated__/IssueTimelineSecondary.graphql'
import type {NewIssueTimelineIssueFragment$key} from './__generated__/NewIssueTimelineIssueFragment.graphql'
import type {NewTimelinePaginationFrontQuery} from './__generated__/NewTimelinePaginationFrontQuery.graphql'
import type {NewIssueTimelineFrontFragment$key} from './__generated__/NewIssueTimelineFrontFragment.graphql'
import type {NewTimelinePaginationBackQuery} from './__generated__/NewTimelinePaginationBackQuery.graphql'
import type {NewIssueTimelineBackFragment$key} from './__generated__/NewIssueTimelineBackFragment.graphql'

const mainTimelineFragment = graphql`
  fragment NewIssueTimelineIssueFragment on Issue {
    id
    url
    ...NewIssueTimelineFrontFragment @arguments(count: 15)
    ...NewIssueTimelineBackFragment @arguments(count: 15)
  }
`

const frontTimelineItemsFragment = graphql`
  fragment NewIssueTimelineFrontFragment on Issue
  @argumentDefinitions(count: {type: "Int"}, cursor: {type: "String"})
  @refetchable(queryName: "NewTimelinePaginationFrontQuery") {
    frontTimelineItems: timelineItems(first: $count, visibleEventsOnly: true, after: $cursor)
      @connection(key: "Issue__frontTimelineItems") {
      pageInfo {
        hasNextPage
      }
      totalCount
      edges {
        node {
          __id
          # TODO: To be used later when rendering the items
          # ...NewIssueTimelineItem
        }
      }
    }
  }
`

const backTimelineItemsFragment = graphql`
  fragment NewIssueTimelineBackFragment on Issue
  @argumentDefinitions(count: {type: "Int"}, cursor: {type: "String"})
  @refetchable(queryName: "NewTimelinePaginationBackQuery") {
    backTimelineItems: timelineItems(last: $count, visibleEventsOnly: true, before: $cursor)
      @connection(key: "Issue__backTimelineItems") {
      pageInfo {
        hasPreviousPage
      }
      totalCount
      edges {
        node {
          __id
          # TODO: To be used later when rendering the items
          # ...NewIssueTimelineItem
        }
      }
    }
  }
`

type NewIssueTimelineProps = {
  issue: IssueViewerIssue$data
  issueSecondary: IssueTimelineSecondary$key | undefined
  highlightedEvent: string | undefined
}
export const NewIssueTimeline = ({issue, issueSecondary}: NewIssueTimelineProps) => {
  const data = useFragment<NewIssueTimelineIssueFragment$key>(mainTimelineFragment, issue)
  const secondaryData = useFragment(
    graphql`
      fragment NewIssueTimelineSecondary on Issue {
        isTransferInProgress
      }
    `,
    issueSecondary,
  )

  const {
    data: {frontTimelineItems: frontTimelineData},
    // hasNext: frontHasMorePages,
    // loadNext: loadMoreFrontItems,
  } = usePaginationFragment<NewTimelinePaginationFrontQuery, NewIssueTimelineFrontFragment$key>(
    frontTimelineItemsFragment,
    data,
  )
  const {
    data: {backTimelineItems: backTimelineData},
    // hasPrevious: backHasMorePages,
    // loadPrevious: loadMoreBackItems,
  } = usePaginationFragment<NewTimelinePaginationBackQuery, NewIssueTimelineBackFragment$key>(
    backTimelineItemsFragment,
    data,
  )

  return (
    <div>
      <h3>New issue timeline placeholder</h3>
      <code>
        {JSON.stringify({
          id: data.id,
          url: data.url,
          isTransferInProgress: secondaryData?.isTransferInProgress,
          totalItemCount: frontTimelineData?.totalCount,
          frontItemIds: frontTimelineData?.edges?.map(e => e?.node?.__id),
          backItemIds: backTimelineData?.edges?.map(e => e?.node?.__id),
        })}
      </code>
    </div>
  )
}

try{ NewIssueTimeline.displayName ||= 'NewIssueTimeline' } catch {}